<template>
  <layout :doc_id="doc_id">
    <template v-slot:body>
      <component
        :is="get_doc_id"
        :key="doc_id">
      </component>
    </template>
  </layout>
</template>

<script>
import layout from '@/components/documentation/layout.vue';
import vastValidator from '@/components/documentation/VastValidator.vue';
import validator from '@/components/documentation/BannerValidator.vue';
import instructions from '@/components/documentation/EmbedInstructions.vue';
import docMenu from '@/components/documentation/menu.vue';

export default {
  name: 'Documentation',
  components: {
    vastValidator,
    validator,
    instructions,
    docMenu,
    layout,
  },
  props: {
    doc_id: {
      type: String,
    },
  },
  data() {
    return {};
  },
  computed: {
    get_doc_id() {
      if (this.doc_id === 'vast_vpaid_validator') {
        return 'vastValidator';
      }
      return this.doc_id ? this.doc_id : 'instructions';
    },
  },
};
</script>

<style scoped lang='stylus'>

</style>
